import React from 'react';
import { Image } from 'react-bootstrap';

export default function ImageLogo() {
    return (
        <div className="headline d-none d-md-block">
            <Image src="/assets/images/baseball.jpg" alt="headline" className="w-100" fluid />
        </div>
    )
}
